import { logMethodCall, log } from './debug';
import {
  browser,
  browserVersion,
} from './env';
import { domLoaded } from './dom';
import { translate as utilsTranslate } from './translate';

export function appendHiddenIframe(url) {
  logMethodCall('appendHiddenIframe');

  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.name = 'cleverpush-iframe';
  iframe.style.display = 'none';
  iframe.style.width = `${1}px`;
  iframe.style.height = `${1}px`;
  iframe.style.opacity = 0;
  iframe.style.pointerEvents = 'none';
  document.body.appendChild(iframe);

  return iframe;
}

export function popup(url, w, h, topParam, leftParam) {
  logMethodCall('popup', url, w, h);

  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  let left = typeof topParam !== 'undefined' && !isNaN(topParam) ? topParam : ((width / 2) - (w / 2)) + dualScreenLeft;
  let top = typeof leftParam !== 'undefined' && !isNaN(leftParam) ? leftParam : ((height / 2) - (h / 2)) + dualScreenTop;

  let additionalParams = 'scrollbars=yes';

  const popupWindow = window.open(url, '_blank', `width=${w}, height=${h}, top=${top}, left=${left}${typeof additionalParams !== 'undefined' ? additionalParams : ''}`);

  if (popupWindow) {
    if (popupWindow.focus) {
      popupWindow.focus();
    }
  }

  return popupWindow;
}

export function initHttpPopup(config) {
  logMethodCall('initHttpPopup', config);

  config.env = 'POPUP';

  if (browser.name === 'Firefox' && browserVersion >= 72) {
    config.showConfirmAlert = true;
    config.showConfirmAlertForce = true;
  }

  if (config.loadConfigFromParent) {
    config.loadConfig = false;
  }

  log.debug('initHttpPopup calling init…');

  this.init(config, (err) => {
    if (err) {
      log.error('initHttpPopup err', err);

      const statusDiv = document.getElementById('status');
      if (statusDiv) {
        statusDiv.innerText = err.message || err.reason || err;
      } else if (window.opener) {
        window.close();
      } else {
        history.back();
      }
    } else {
      // Firefox 72: Push notification prompting can only be done from a user gesture
      if (browser.name === 'Firefox' && browserVersion >= 72) {
        import('../confirm').then(({ default: Confirm }) => {
          log.debug('showConfirmAlert = true 5');
          this.config.showConfirmAlert = true;
          this.config.showConfirmAlertForce = true;
          this.confirm = new Confirm(this, this.subscriptionManager);
          this.subscriptionManager.setConfirm(this.confirm);
          domLoaded().then(() => {
            this.confirm.appendConfirmBox(`${this.config.confirmAlertNativeTheme} ${this.config.confirmAlertNativeTheme}-native`);

            if (this.confirm.denyButton) {
              this.confirm.denyButton.style.display = 'none';
            }
            const confirmInfo = this.confirm.confirmBox.querySelector('.cleverpush-confirm-info');
            if (confirmInfo) {
              confirmInfo.style.display = 'none';
            }
          });
        });
      }

      window.onbeforeunload = () => utilsTranslate('windowclose.confirm');
    }
  });
}
